import inboxIcon from '../../../../media/shared-access/ic-inbox.svg'
import trashIcon from '../../../../media/shared-access/ic-trash.svg'
import sentIcon from '../../../../media/shared-access/ic-sent.svg'
import draftIcon from '../../../../media/shared-access/ic-draft.svg'
import markIcon from '../../../../media/shared-access/ic-marked.svg'
import { useIntl } from 'react-intl'
import { useLocation, useNavigate } from 'react-router-dom'

export const InboxMenu = ({
  status,
  setStatus,
  totalInboxCount,
  totalDraftCount,
  totalMarkedCount,
  totalSentCount,
  totalTrashCount,
  setSearch,
  setCurrentPage,
  setIsNewMessageClicked,
}: any) => {
  const { formatMessage } = useIntl()
  const navigate = useNavigate()
  const location = useLocation()

  console.log(location.pathname, ' path')
  const handleInboxMenuClick = (status: any) => {
    const searchParams = new URLSearchParams(location.search)
    if (searchParams.has('id')) {
      searchParams.delete('id')
      searchParams.delete('isDeleted')
    }
    searchParams.set('status', status)
    navigate(`${location.pathname}?${searchParams.toString()}`)
  }

  return (
    <>
      <div className='card card-flush mb-0'>
        <div className='card-body'>
          <div
            className='btn bg-primary custom-button-property text-white fw-normal w-100 mb-7'
            onClick={() => {
              handleInboxMenuClick('message')
              setStatus('MESSAGE')
              setSearch('')
              setCurrentPage(1)
              setIsNewMessageClicked(true)
              console.log('inbox')
            }}
          >
            {formatMessage({ id: 'New Message' })}
          </div>
          <div className='menu menu-column menu-rounded menu-state-bg '>
            <div
              className='menu-item mb-1'
              onClick={() => {
                handleInboxMenuClick('inbox')
                setStatus('INBOX')
                setSearch('')
                setCurrentPage(1)
                console.log('inbox')
              }}
            >
              <span className={`menu-link ${status === 'INBOX' ? 'active' : ''}`}>
                <img src={inboxIcon} alt='' className='menu-item-icon' />
                <span className='menu-title fw-semibold'>{formatMessage({ id: 'Inbox' })}</span>
                <span className='badge badge-light-success'>{totalInboxCount}</span>
              </span>
            </div>
            <div
              className='menu-item mb-1'
              onClick={() => {
                handleInboxMenuClick('starred')
                setStatus('STARRED')
                setSearch('')
                setCurrentPage(1)
                console.log('marked')
              }}
            >
              <span className={`menu-link ${status === 'STARRED' ? 'active' : ''}`}>
                <img src={markIcon} alt='' className='menu-item-icon' />
                <span className='menu-title fw-semibold'>{formatMessage({ id: 'Marked' })}</span>
                <span className='badge badge-light-success'>{totalMarkedCount}</span>
              </span>
            </div>
            <div
              className='menu-item mb-1'
              onClick={() => {
                handleInboxMenuClick('draft')
                setStatus('DRAFT')
                setSearch('')
                setCurrentPage(1)
                console.log('draft')
              }}
            >
              <span className={`menu-link ${status === 'DRAFT' ? 'active' : ''}`}>
                <img src={draftIcon} alt='' className='menu-item-icon' />
                <span className='menu-title fw-semibold'>{formatMessage({ id: 'Draft' })}</span>
                <span className='badge badge-light-warning'>{totalDraftCount}</span>
              </span>
            </div>
            <div
              className='menu-item mb-1'
              onClick={() => {
                handleInboxMenuClick('sent')
                setStatus('SENT')
                setSearch('')
                setCurrentPage(1)
                console.log('sent')
              }}
            >
              <span className={`menu-link ${status === 'SENT' ? 'active' : ''}`}>
                <img src={sentIcon} alt='' className='menu-item-icon' />
                <span className='menu-title fw-semibold'>{formatMessage({ id: 'Sent' })}</span>
                <span className='badge badge-light-primary'>{totalSentCount}</span>
              </span>
            </div>
            <div
              className='menu-item'
              onClick={() => {
                handleInboxMenuClick('trash')
                setStatus('TRASH')
                setSearch('')
                setCurrentPage(1)
                console.log('trash')
              }}
            >
              <span className={`menu-link ${status === 'TRASH' ? 'active' : ''}`}>
                <img src={trashIcon} alt='' className='menu-item-icon' />
                <span className='menu-title fw-semibold'>{formatMessage({ id: 'Trash' })}</span>
                <span className='badge badge-light-danger'>{totalTrashCount}</span>
              </span>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
